import { useState, useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  Typography,
  TextField,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  Modal,
  InputLabel,
  IconButton,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Snackbar,
  Select,
  Stack,
  Paper
} from "@mui/material";
import MuiAlert from '@mui/material/Alert';

import axios from  "axios";
import { Formik } from 'formik';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '80%', md: 400 },
    maxHeight: '66vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    overflow: 'scroll'
};

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Support = () => {
    const [ticketData, setTicketData] = useState([]);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleOpenEdit = (val) => {
        setValToEdit(val);
        setOpenEdit(true);
    };
    const handleCloseEdit = () => {
        setValToEdit([]);
        setOpenEdit(false);
    };
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const [openDelDialog, setOpenDelDialog] = useState(false);
    const [open, setOpen] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [valToEdit, setValToEdit] = useState([]);
    const [id, setId] = useState(null);

    const handleDeleteDialog = (id) => {
        setId(id);
        setOpenDelDialog(true);
    };
  
    const handleCloseDeleteDialog = () => {
        setId(null);
        setOpenDelDialog(false);
    };
  
    const handleDelete = async (id) => {
        await axios.delete(`${process.env.REACT_APP_API_URL}/api/dashboard/support/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            }
        });

        // update states
        const support = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/support`, {
            headers: {
              Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            }
        });
        let number = 0;
        setTicketData(support.data.result.map((v) => {
            number+=1;
            return { ...v, no: number };
        }));
        
        handleCloseDeleteDialog();
    };

    const [openAlert, setOpenAlert] = useState(false);
    const [alertStatus, setAlertStatus] = useState('success');
    const [alertMessage, setAlertMessage] = useState('');
    const handleClickAlert = () => {
        setOpenAlert(true);
    };

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    useEffect(() => {
        const getTicket = async () => {
          try {
            const support = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/support`, {
              headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
              }
            });
            let number = 0;
            setTicketData(support.data.result.map((v) => {
              number+=1;
              return { ...v, no: number };
            }));
          } catch (err) {
            console.log(err);
          }
        };
        getTicket();
    }, [])

    return (
        <div style={{ minHeight: '80vh', padding: '0px 11px'}}>
            <Snackbar
                open={openAlert}
                autoHideDuration={2500}
                onClose={handleCloseAlert}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                key={'top' + 'center'}
            >
                <Alert onClose={handleCloseAlert} severity={alertStatus} sx={{ width: '100%' }}>
                    {alertMessage}
                </Alert>
            </Snackbar>
            <Dialog
                open={openDelDialog}
                onClose={handleCloseDeleteDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Apakah anda akan menghapus data ?
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleCloseDeleteDialog}>Batal</Button>
                <Button onClick={() => handleDelete(id)}>
                    Ya
                </Button>
                </DialogActions>
            </Dialog>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={modalStyle}>
                <Formik
                    initialValues={{ masalah: null, namacs: null, note: null }}
                    validate={values => {
                        const errors = {};
                        if (!values.masalah) {
                            errors.masalah = 'Wajib diisi';
                        }
                        if (!values.namacs) {
                            errors.namacs = 'Wajib diisi';
                        }
                        if (!values.note) {
                            errors.note = 'Wajib diisi';
                        }
                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting }) => {
                        try {
                            await axios.post(`${process.env.REACT_APP_API_URL}/api/dashboard/support`, values, {
                                headers: {
                                    Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                }
                            });
                            // update states
                            const support = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/support`, {
                                headers: {
                                  Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                }
                            });
                            let number = 0;
                            setTicketData(support.data.result.map((v) => {
                                number+=1;
                                return { ...v, no: number };
                            }));
                            setAlertStatus('success');
                            setAlertMessage('Submit support ticket berhasil')
                            setOpenAlert(true);
                            handleClose();
                        } catch (err) {
                            console.log(err);
                            setSubmitting(false);
                        }
                    }}
                >
                    {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    /* and other goodies */
                    }) => (
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                <Typography id="modal-modal-title" variant="subtitle1" fontWeight="700">
                                    MASUKAN SUPPORT TICKET
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Masalah</InputLabel>
                                    <Select
                                        fullWidth
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Masalah"
                                        onChange={handleChange}
                                        name="masalah"
                                    >
                                        <MenuItem value="Retur &#38; Refund">Retur &#38; Refund</MenuItem>
                                        <MenuItem value="Barang Tidak Sampai">Barang Tidak Sampai</MenuItem>
                                        <MenuItem value="Masalah Website">Masalah Website</MenuItem>
                                        <MenuItem value="Service CS">Service CS</MenuItem>
                                        <MenuItem value="Lain-lain">Lain-lain</MenuItem>
                                    </Select>
                                </FormControl>
                                <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                    {errors.masalah && touched.masalah && errors.masalah}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Nama CS</InputLabel>
                                    <Select
                                        fullWidth
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Nama CS"
                                        onChange={handleChange}
                                        name="namacs"
                                    >
                                        <MenuItem value="Yara">Yara</MenuItem>
                                        <MenuItem value="Intan">Intan</MenuItem>
                                        <MenuItem value="Daniar">Daniar</MenuItem>
                                        <MenuItem value="Zahra">Zahra</MenuItem>
                                        <MenuItem value="Tya">Tya</MenuItem>
                                        <MenuItem value="IT Support">IT Support</MenuItem>
                                        <MenuItem value="Lainnya">Lainnya</MenuItem>
                                    </Select>
                                </FormControl>
                                <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                    {errors.namacs && touched.namacs && errors.namacs}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="outlined-multiline-flexible"
                                    required
                                    fullWidth
                                    label="Note"
                                    multiline
                                    rows={4}
                                    onChange={handleChange}
                                    name="note"
                                />
                                <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                    {errors.note && touched.note && errors.note}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sx={{ textAlign: 'right', padding: '10px 0px' }}>
                                <Button variant="contained" type="submit" disabled={isSubmitting}>Submit</Button>
                            </Grid>
                        </Grid>
                    </form>
                    )}
                </Formik>
                </Box>
            </Modal>
            <Modal
                open={openEdit}
                onClose={handleCloseEdit}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={modalStyle}>
                    <Formik
                        initialValues={{ masalah: null, namacs: null, note: null }}
                        validate={values => {
                            const errors = {};
                            return errors;
                        }}
                        onSubmit={async (values, { setSubmitting }) => {
                            const filteredVal = Object.keys(values).reduce((newObj, key) => {
                                const value = values[key];
                                if (value !== null) {
                                    newObj[key] = value;
                                }
                                return newObj;
                            }, {});
                            if (Object.keys(filteredVal).length === 0) {
                                setAlertStatus('warning');
                                setAlertMessage('Tidak ada perubahan')
                                setOpenAlert(true);
                                setSubmitting(false);
                            } else {
                                try {
                                    await axios.put(`${process.env.REACT_APP_API_URL}/api/dashboard/support/${valToEdit.idsupport}`, filteredVal, {
                                        headers: {
                                            Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                        }
                                    });
                                    // update states
                                    const support = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/support`, {
                                        headers: {
                                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                        }
                                    });
                                    let number = 0;
                                    setTicketData(support.data.result.map((v) => {
                                        number+=1;
                                        return { ...v, no: number };
                                    }));
                                    setAlertStatus('success');
                                    setAlertMessage('Data berhasil dirubah')
                                    setOpenAlert(true);
                                    handleCloseEdit();
                                } catch (err) {
                                    console.log(err);
                                    setSubmitting(false);
                                }
                            }
                        }}
                    >
                        {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        /* and other goodies */
                        }) => (
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                    <Typography id="modal-modal-title" variant="subtitle1" fontWeight="700">
                                        EDIT SUPPORT TICKET
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Masalah</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Masalah"
                                            onChange={handleChange}
                                            name="masalah"
                                            defaultValue={valToEdit.masalah}
                                        >
                                            <MenuItem value="Retur &#38; Refund">Retur &#38; Refund</MenuItem>
                                            <MenuItem value="Barang Tidak Sampai">Barang Tidak Sampai</MenuItem>
                                            <MenuItem value="Masalah Website">Masalah Website</MenuItem>
                                            <MenuItem value="Service CS">Service CS</MenuItem>
                                            <MenuItem value="Lain-lain">Lain-lain</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                        {errors.masalah && touched.masalah && errors.masalah}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Nama CS</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Nama CS"
                                            onChange={handleChange}
                                            name="namacs"
                                            defaultValue={valToEdit.namacs}
                                        >
                                            <MenuItem value="Yara">Yara</MenuItem>
                                            <MenuItem value="Intan">Intan</MenuItem>
                                            <MenuItem value="Daniar">Daniar</MenuItem>
                                            <MenuItem value="Zahra">Zahra</MenuItem>
                                            <MenuItem value="Tya">Tya</MenuItem>
                                            <MenuItem value="IT Support">IT Support</MenuItem>
                                            <MenuItem value="Lainnya">Lainnya</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                        {errors.namacs && touched.namacs && errors.namacs}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        id="outlined-multiline-flexible"
                                        required
                                        fullWidth
                                        label="Note"
                                        multiline
                                        rows={4}
                                        onChange={handleChange}
                                        name="note"
                                        defaultValue={valToEdit.note}
                                    />
                                    <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                        {errors.note && touched.note && errors.note}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sx={{ textAlign: 'right', padding: '10px 0px' }}>
                                    <Button variant="contained" type="submit" disabled={isSubmitting}>Submit</Button>
                                </Grid>
                            </Grid>
                        </form>
                        )}
                    </Formik>
                </Box>
            </Modal>
            <Grid container>
                <Grid item xs={12} my={2}>
                    <Typography variant="h5" fontWeight="700">Support Ticket</Typography>
                </Grid>
            </Grid>
            <Stack direction="row" spacing={2} sx={{ py: '20px' }}>
                <Button variant="contained" startIcon={<AddCircleIcon />} onClick={handleOpen}>
                  Tambah Ticket
                </Button>
              </Stack>
              <TableContainer component={Paper} sx={{ maxHeight: {xs: '66vh', sm: 640, md: 768} }}>
                <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>No</TableCell>
                      <TableCell align="left">Tanggal</TableCell>
                      <TableCell align="left">Masalah</TableCell>
                      <TableCell align="left">Nama CS</TableCell>
                      <TableCell align="left">Note</TableCell>
                      <TableCell align="left">Status</TableCell>
                      <TableCell align="left">Aksi</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {ticketData.map((row) => (
                      <TableRow
                        key={row.idmitraagen}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell align="left">{row.no}</TableCell>
                        <TableCell align="left">{row.tgl}</TableCell>
                        <TableCell align="left">{row.masalah}</TableCell>
                        <TableCell align="right">{row.namacs}</TableCell>
                        <TableCell align="left">{row.note}</TableCell>
                        <TableCell align="left">{row.status}</TableCell>
                        <TableCell align="left">
                          <Button><DeleteIcon onClick={() => handleDeleteDialog(row.idsupport)} /></Button>
                          <Button><EditIcon onClick={() => handleOpenEdit(row)} /></Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
        </div>
    )
}

export default Support
